import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  byId: {},
  allIds: [],
  status: 'idle', // Can be 'idle', 'loading', 'succeeded', or 'failed'
  error: null, // To store any errors
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    fetchFavorites(state, action) {
      const favorites = action.payload;

      // Reset state before fetching new data
      state.byId = {};
      state.allIds = [];

      favorites.forEach((favorite) => {
        state.byId[favorite.itemId] = favorite;
        state.allIds.push(favorite.itemId);
      });

      state.status = 'succeeded'; // Mark fetch as successful
      state.error = null; // Clear any previous errors
    },
    addFavorite(state, action) {
      const favorite = action.payload;

      state.byId[favorite.itemId] = favorite;

      if (!state.allIds.includes(favorite.itemId)) {
        state.allIds.push(favorite.itemId);
      }
    },
    removeFavorite(state, action) {
      const itemId = action.payload;

      // Remove the favorite by its itemId
      delete state.byId[itemId];
      state.allIds = state.allIds.filter((favId) => favId !== itemId);
    },
    setLoading(state) {
      state.status = 'loading';
    },
    setError(state, action) {
      state.status = 'failed';
      state.error = action.payload; // Store the error message
    },
    clearError(state) {
      state.error = null; // Clear the error state
    },
    resetFavorites(state) {
      state.byId = {};
      state.allIds = [];
      state.status = "idle";
      state.error = null;
    },
  },
});

export const {
  fetchFavorites,
  addFavorite,
  removeFavorite,
  setLoading,
  setError,
  clearError,
  resetFavorites,
} = favoritesSlice.actions;

export default favoritesSlice.reducer;
